
import { useParams } from "react-router-dom"
import { get_portfolio_item_by_id } from '../../services'
import './portfolio_items.css'
import './portfolio_items_desktop.css'

import { PgLayoutGrid } from '../PageLayout'

export function PortfolioItemPreview({ item, handleClick }) {
    return (
        <div className="portfolio-preview">
            <div className="preview-container" onClick={() => handleClick(item)}>
                <img className="portfolio-img" src={item.photos[0]} alt={item.title} />
                {/* <h5 className="portfolio-label" style={{fontWeight:'200'}}>{item.title}</h5> */}
            </div>
        </div>
    )
}

export function portfolioMapper(item_list, itemAction) {
    return item_list.map(item => <PortfolioItemPreview item={item} handleClick={itemAction} />)
}

export function PortfolioItemGrid({ items, handleSelect }) {
    return (
        <PgLayoutGrid>
            {portfolioMapper(items, handleSelect)}
        </PgLayoutGrid>
    )
}
